export default __webpack_public_path__ + "logoOkta.df39a6d5.svg";